import React, { Fragment } from "react";
import { compose } from "redux";
import { withStyles } from "@material-ui/core/styles";
import { Grid, Divider } from "@material-ui/core";
import GridPercentInput from "../Components/GridPercentInput";
import { transformNumber } from "utils/transformNumber";
import SectionTitle from '../Components/SectionTitle';

class Fees extends React.Component {
  state = {
    originationFee: "",
    extensionFees: "",
    brokerFee: "",
    exitFee: "",
    otherFee:""
  };

  static getDerivedStateFromProps(props, state) {
    const { loan } = props;
    return {
      originationFee: loan.originationFee || loan.originationFee === 0 ? loan.originationFee : "",
      extensionFees: loan.extensionFees || loan.extensionFees === 0 ? loan.extensionFees : "",
      brokerFee:loan.brokerFee || loan.brokerFee === 0 ? loan.brokerFee : "",
      exitFee: loan.exitFee || loan.exitFee === 0 ? loan.exitFee : "",
      otherFee: loan.otherFee || loan.otherFee === 0 ? loan.otherFee : ""
    };
  }

  render() {
    const {
      loan,
      handleChange,
      handleTextChange,
      isNewLoan,
      isEditing,
      isInitialized
    } = this.props;

    return (
      <Fragment>
        <span id="loan_fees"> 
        <Grid hidden={!isInitialized} item xs={7}>
            <SectionTitle>Fees</SectionTitle>
        </Grid>
        <Grid container item={true} xs={12}>
          <GridPercentInput
            name="originationFee"
            label="Origination Fees"
            value={this.state.originationFee}
            onBlur={item => {
              handleTextChange({
                target: {
                  name: "originationFee",
                  value:
                    item.target.value === ""
                      ? ""
                      : transformNumber(item.target.value) 
                }
              });
            }}
            isEditing={isEditing}
            shouldShow={isInitialized}
          />
        </Grid>
        <Grid container item={true} xs={12}>
          <GridPercentInput
            name="extensionFees"
            label="Extension Fees"
            value={this.state.extensionFees}
            onBlur={item => {
              handleTextChange({
                target: {
                  name: "extensionFees",
                  value:
                    item.target.value === ""
                      ? ""
                      : transformNumber(item.target.value) 
                }
              });
            }}
            isEditing={isEditing}
            shouldShow={isInitialized}
          />
        </Grid>
        <Grid container item={true} xs={12}>
          <GridPercentInput
            name="brokerFee"
            label="Broker Fees"
            value={this.state.brokerFee}
            onBlur={item => {
              handleTextChange({
                target: {
                  name: "brokerFee",
                  value:
                    item.target.value === ""
                      ? ""
                      : transformNumber(item.target.value) 
                }
              });
            }}
            isEditing={isEditing}
            shouldShow={isInitialized}
          />
        </Grid>
        <Grid container item={true} xs={12}>
          <GridPercentInput
            name="exitFee"
            label="Exit Fees"
            value={this.state.exitFee}
            onBlur={item => {
              handleTextChange({
                target: {
                  name: "exitFee",
                  value:
                    item.target.value === ""
                      ? ""
                      : transformNumber(item.target.value)
                }
              });
            }}
            isEditing={isEditing}
            shouldShow={isInitialized}
          />
        </Grid>
        <Grid container item={true} xs={12}>
          <GridPercentInput
            name="otherFee"
            label="Other Fees"
            value={this.state.otherFee}
            onBlur={item => {
              handleTextChange({
                target: {
                  name: "otherFee",
                  value:
                    item.target.value === ""
                      ? ""
                      : transformNumber(item.target.value)
                }
              });
            }}
            isEditing={isEditing}
            shouldShow={isInitialized}
          />
        </Grid>
        </span>
      </Fragment>
    );
  }
}

export default Fees;
